export type LegalPageContent = {
  title: string;
  lead: string;
  sections: Array<[heading: string, text: string]>;
  links?: Array<[label: string, href: string]>;
};

export const LEGAL_CONTENT: Record<string, LegalPageContent> = {
  guide: {
    title: 'MailBots guide',
    lead: 'From free disposable addresses to catch-all subdomains for automation.',
    sections: [
      ['Free bot & extension', 'Open the Telegram bot or the browser extension, accept the disclosure, create an @mailbots.top address and use it for up to 24 hours.'],
      ['Paid catch-all', 'Sign in, activate a plan, add a subdomain, configure the TXT and MX records, send an external probe message, then provision the mailbox.'],
      ['Mail clients', 'Use the web inbox or the one-time credential to connect over POP3S 995 or IMAPS 993 at mx1.mailbots.top.'],
    ],
  },
  privacy: {
    title: 'Privacy policy',
    lead: 'MailBots minimizes stored data and automatically deletes message content.',
    sections: [
      ['Free service', 'The Telegram bot does not copy message content into its database. The browser extension identifies you only by an anonymous device token — no account, name or email — and retains normalized message text and the verification codes (OTP) found in it for no more than 24 hours. "Delete my data" in the extension removes your addresses, messages, push subscriptions and that token from the server.'],
      ['Paid catch-all', 'Raw MIME remains on the mail gateway for no more than 72 hours. The control plane keeps only normalized content, OTP and metadata with the same maximum TTL.'],
      ['Providers and rights', 'Infrastructure providers include Cloudflare, the VPS provider, Telegram, Google OAuth and Paddle (merchant of record for card and PayPal payments). Users may access, export and delete their organization data by contacting support.'],
    ],
  },
  terms: {
    title: 'Terms of service',
    lead: 'A receive-only service for QA, development and legitimate automation.',
    sections: [
      ['Provider', 'MailBots is the service provider and product brand. Questions about these terms or the service can be sent to support@mailbots.top.'],
      ['Service', 'Delivery is not guaranteed. Do not use MailBots for important accounts, legal notices or financial transactions.'],
      ['Billing', 'Starter is $10 and Pro is $15 monthly. Card and PayPal orders are processed by Paddle.com, our merchant of record, and renew automatically until canceled; approved USDT TRC20 payments add 30 days. Refunds and withdrawal rights are described in the MailBots Refund Policy.'],
      ['Suspension', 'MailBots may limit or suspend access after quota exhaustion, Acceptable Use violations or infrastructure risk.'],
    ],
  },
  'refund-policy': {
    title: 'Refund policy',
    lead: 'How cancellations, withdrawals and refund requests are handled for MailBots purchases.',
    sections: [
      ['Card and PayPal purchases', 'Paddle.com is the merchant of record for card and PayPal purchases. Refunds, statutory withdrawal rights and eligibility are handled under the Paddle Refund Policy and applicable consumer law. Nothing in this policy limits mandatory consumer rights.'],
      ['Requesting a refund', 'Use Paddle Buyer Support or the support link in your Paddle receipt or customer portal to request a refund. You may also contact MailBots support if you need help identifying a transaction.'],
      ['Canceling a subscription', 'Cancel through the Paddle customer portal to stop future renewals. Cancellation normally takes effect at the end of the current billing period and does not by itself refund a completed charge.'],
      ['USDT payments', 'USDT TRC20 payments are manually reviewed and blockchain transfers cannot be reversed by MailBots. Contact support@mailbots.top about an activation problem or refund request; eligibility is reviewed case by case subject to applicable law.'],
    ],
    links: [
      ['Paddle Refund Policy', 'https://www.paddle.com/legal/refund-policy'],
      ['Paddle Buyer Support', 'https://paddle.net/'],
    ],
  },
  'acceptable-use': {
    title: 'Acceptable Use',
    lead: 'Rules that protect the inbound mail infrastructure and the developer community.',
    sections: [
      ['Allowed', 'QA, integration tests, staging, internal automation and verification mail for systems you are authorized to use.'],
      ['Prohibited', 'Spam, phishing, account farming, fraud, malware, or bypassing third-party safeguards and limits.'],
      ['Enforcement', 'We may rate-limit traffic, deny senders, suspend domains or organizations, and terminate serious violations.'],
    ],
  },
};
